var AIChatMessage = React.createClass({

    getInitialState: function () {
        return {
            likeDisabled: false, dislikeDisabled: false,
        };
    },

    handleReaction: function (messageId, reaction) {
        let url = `${Config.contextPath}/controller/services/gpt?action=feedback`;
        let data = {
            conversationId: this.props.chatItem.conversationId,
            messageId: messageId,
            feedback: reaction
        };

        var headers = new Headers();
        headers.append('SToken', Config.csrf.value);

        fetch(url, {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(data)
        })
            .then(response => response.json())
            .then(res => {
                if (reaction === 1) {
                    this.setState({ likeDisabled: true, dislikeDisabled: false });
                } else if (reaction === -1) {
                    this.setState({ likeDisabled: false, dislikeDisabled: true });
                }
            })
            .catch(error => {
                console.error('Error sending or receiving chatItems:', error);
            });
    },

    handleCopyToClipboard: function () {
        const textToCopy = this.props.chatItem.details.text;
        const textArea = document.createElement('textarea');
        textArea.value = textToCopy;
        document.body.appendChild(textArea);

        textArea.select();
        document.execCommand('copy');

        document.body.removeChild(textArea);
        alert('Message copied to clipboard!');
    },

    render: function () {
        var self = this;
        let chatItem = this.props.chatItem;
        let details = chatItem.details;
        let references = details.references;
        return (
            <div key={this.props.key} className={`ai-chat-message-item ${chatItem.sender}`}>
                <div id={details.id} className={`ai-chat-message ${chatItem.sender}`}>
                    <div dangerouslySetInnerHTML={{ __html: details.text }} />
                    {chatItem.sender === "bot" && references && references.length > 0 && (
                        <div className="ai-chat-message-citations-container">
                            <span hidden={!references}>Learn more:</span>
                            <div className="ai-chat-message-citations-list">
                                {references.map((reference, index) =>
                                    <div key={reference.id} className="ai-chat-message-citation">
                                        <a
                                            href={`${Config.contextPath}/app/portlets/results/viewsolution.jsp?solutionid=${reference.id}&page=-1&position=${index}`}
                                            target="_blank"
                                            title={reference.title}
                                        >
                                            {reference.title}
                                        </a>
                                    </div>
                                )}
                            </div>
                        </div>
                    )}
                    {chatItem.sender === 'bot' && details.isFeedbackAllowed && (
                        <div className="ai-chat-message-buttons">
                            <button title="Like" onClick={() => self.handleReaction(details.id, 1)} disabled={this.state.likeDisabled}>
                                <span className="glyphicon glyphicon-thumbs-up"></span>
                            </button>
                            <button title="Dislike" onClick={() => self.handleReaction(details.id, -1)} disabled={this.state.dislikeDisabled}>
                                <span className="glyphicon glyphicon-thumbs-down"></span>
                            </button>
                            <button title="Copy to Clipboard" onClick={this.handleCopyToClipboard}>
                                <span className="glyphicon glyphicon-copy"></span>
                            </button>
                        </div>
                    )}
                </div>
            </div>

        );
    }
});
